import { useState, useEffect, useRef } from "react";
import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";

export default function FAQ() {
  const [showText, setShowText] = useState(false);
  const [showImages, setShowImages] = useState(false);
  const graySectionRef = useRef(null);
  const imagesSectionRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [photo, setPhoto] = useState([]);
  const API_BASE = "";
  const [ipAddress, setIPAddress] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetch("save_ip.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ip: ipAddress }),
    });
  }, [ipAddress]);

  useEffect(() => {
    const fetchPhotoHome = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photohome`);
        if (!res.ok) throw new Error("Błąd pobierania danych z API");

        const data = await res.json();
        console.log("data: ", data[0].filename);
        const photo = {
          ...data,
          fullSrc: `${API_BASE}/files/${data.fullUrl}`,
        };

        setPhoto(`${API_BASE}/files/${data[0].filename}`);
      } catch (err) {
        console.error("Błąd:", err);
      } finally {
        console.log("ok");
      }
    };

    fetchPhotoHome();
  }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 900);
    const imageTimer = setTimeout(() => 1600);
    return () => {
      clearTimeout(textTimer);
      clearTimeout(imageTimer);
    };
  }, []);
  useEffect(() => {
    console.log("Photo: ", photo);
  }, []);

  useEffect(() => {
    const textObserver = new IntersectionObserver(
      ([entry]) => {
        setShowText(entry.isIntersecting);
      },
      { threshold: 0.4 },
    );
    if (graySectionRef.current) textObserver.observe(graySectionRef.current);
    const imagesObserver = new IntersectionObserver(
      ([entry]) => {
        setShowImages(entry.isIntersecting);
      },
      { threshold: 0.4 },
    );
    if (imagesSectionRef.current)
      imagesObserver.observe(imagesSectionRef.current);

    return () => {
      textObserver.disconnect();
      imagesObserver.disconnect();
    };
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };
  const faqData = [
    {
      question:
        "Fotograf nieruchomości Warszawa - czy profesjonalne zdjęcia pomagają szybciej sprzedać dom lub mieszkanie?",
      answer:
        "Tak. Profesjonalne zdjęcia zwiększają liczbę zapytań i poprawiają pierwsze wrażenie, co często skraca czas sprzedaży.",
    },
    {
      question: "Jak przygotować mieszkanie do zdjęć na sprzedaż w Warszawie?",
      answer:
        "Posprzątaj, schowaj rzeczy osobiste i opróżnij blaty. Usuń widoczne kable, ładowarki i listwy zasilające, odsłoń okna i włącz wszystkie światła.",
    },
    {
      question:
        "Zdjęcia dla Airbnb i Booking Warszawa - czy wykonujesz sesje pod najem krótkoterminowy?",
      answer:
        "Tak. Wykonuję zdjęcia dla Airbnb i Booking, które poprawiają prezentację oferty i zwiększają liczbę rezerwacji.",
    },
    {
      question:
        "Ile trwa sesja zdjęciowa mieszkania - fotograf nieruchomości Warszawa?",
      answer:
        "Najczęściej 60 - 120 minut, w zależności od metrażu i zakresu usług.",
    },
    {
      question: "Ile kosztuje sesja zdjęciowa nieruchomości w Warszawie?",
      answer:
        "Cena sesji zdjęciowej zaczyna się od 600 zł netto. Ostateczna wycena zależy od metrażu, liczby pomieszczeń i zakresu usług.",
    },
    {
      question:
        "Fotograf nieruchomości Warszawa - na jakim obszarze realizujesz sesje?",
      answer:
        "Działam na terenie Warszawy oraz okolicznych miejscowości. Dojazd na tym obszarze jest wliczony w cenę sesji.",
    },
    {
      question: "Kiedy otrzymam gotowe zdjęcia nieruchomości?",
      answer: "Zdjęcia dostarczam w ciągu 24 godzin od wykonania sesji.",
    },

    {
      question:
        "Fotograf wnętrz Warszawa - czy wykonujesz sesje dla architektów i projektantów?",
      answer:
        "Tak. Wykonuję sesje realizacji wnętrz do portfolio oraz materiałów marketingowych.",
    },
    {
      question:
        "Fotograf hoteli i restauracji Warszawa - czy realizujesz zdjęcia obiektów komercyjnych?",
      answer:
        "Tak. Fotografuję hotele, pensjonaty i restauracje do stron www, social mediów i kampanii reklamowych.",
    },
    {
      question:
        "Fotografia produktowa Warszawa - czy robisz zdjęcia mebli i wyposażenia wnętrz?",
      answer:
        "Tak. Wykonuję fotografię produktową mebli, detali i aranżacji wnętrz.",
    },
    {
      question:
        "Film promocyjny wnętrz Warszawa - czy oferujesz wideo, drona i spacery 360?",
      answer:
        "Tak. Realizuję filmy promocyjne, ujęcia z drona oraz wirtualne spacery 360°.",
    },
    {
      question: "Ile kosztuje sesja zdjęciowa dla klientów biznesowych?",
      answer:
        "Cena sesji zaczyna się od 600 zł netto i zależy od skali projektu oraz zakresu materiałów.",
    },
    {
      question:
        "Fotograf wnętrz Warszawa - na jakim obszarze realizujesz sesje?",
      answer:
        "Działam na terenie Warszawy oraz okolicznych miejscowości, m.in. Konstancin-Jeziorna, Piaseczno, Pruszków, Otwock, Legionowo, Wołomin, Ząbki, Marki i inne. Dojazd na tym obszarze jest wliczony w cenę sesji.",
    },
  ];

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqData.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.answer,
            },
          })),
        })}
      </script>

      <Helmet>
        <title>Fotografia Wnętrz i Nieruchomości | Tomasz Fotograf</title>
        <meta
          name="description"
          content="Profesjonalna fotografia wnętrz, nieruchomości, apartamentów, domów i hoteli. Zdjęcia, które zwiększają zainteresowanie ofertą."
        />
      </Helmet>

      <Menu />
      <div className="fullpage">
        <section className="section section-gray" ref={graySectionRef}>
          <AnimatePresence>
            {showText && (
              <motion.div
                className="fade-in-text"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={textVariants}
              >
                <p className="h1a">FAQ</p>
                <Row>
                  {faqData.map((item, index) => (
                    <div key={index}>
                      <p className="h4a">{item.question}</p>
                      <p className="h4b">- {item.answer}</p>
                      {index < faqData.length - 1 && <hr />}
                    </div>
                  ))}
                </Row>
              </motion.div>
            )}
          </AnimatePresence>
        </section>
      </div>
    </>
  );
}
